import type { MutateOptions } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import useInvalidateOpportunityQueries from "app/pages/sales-intelligence/pages/opportunity-list/hooks/useInvalidateOpportunityQueries";
import { fetchWorkspacesThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import type { RemoveFromListParams } from "app/pages/sales-intelligence/sub-modules/opportunities/query/mutations/useRemoveFromListMutation";
import { useRemoveFromListMutation } from "app/pages/sales-intelligence/sub-modules/opportunities/query/mutations/useRemoveFromListMutation";

type Options = Pick<MutateOptions<void, unknown, RemoveFromListParams>, "onSuccess">;

export const useRemoveLeadsFromListMutation = ({ onSuccess }: Options = {}) => {
    const invalidateOpportunitiesQueries = useInvalidateOpportunityQueries();
    const dispatch = useDispatch();

    return useRemoveFromListMutation({
        onSuccess(data, variables, context) {
            void invalidateOpportunitiesQueries(variables.listParams.id);
            void dispatch(fetchWorkspacesThunk());

            onSuccess?.(data, variables, context);
        },
    });
};
